import React, { type JSX } from 'react';
import { IPrismicLink, PrismicLinkContext } from '@monofront/types';
import StickerBackground from '../../visuals/Backgrounds/StickerBackground';
import ArrowLoopDoodle from '../../visuals/Illustrations/ArrowLoopDoodle';
import HyperLink from '../HyperLink';
import { PrismicLink } from '../../prismic-link/PrismicLink';

interface ICta {
  link: IPrismicLink;
  label: string;
  trackingId?: string | null;
  context: PrismicLinkContext;
}

interface IBubbleCard {
  title: JSX.Element | string;
  content: JSX.Element;
  sideText?: string | null;
  cta?: ICta | null;
  backgroundColor?: string | null;
}

const BubbleCard: React.FC<IBubbleCard> = ({
  title,
  content,
  sideText,
  cta,
}) => {
  return (
    <>
      <div className="bubble-card">
        <StickerBackground
          UNSAFE_className="bubble-background desktop-only"
          variant="A"
        />
        <StickerBackground
          UNSAFE_className="bubble-background mobile-only"
          variant="B"
        />

        <div className="bubble-content">
          <h3 className="bubble-title accent-title">{title}</h3>
          {content}
          {cta && (
            <PrismicLink
              link={cta.link}
              context={cta.context}
              trackingId={cta.trackingId || undefined}
            >
              <HyperLink className="bubble-cta" variant="button-primary-span">
                {cta.label}
              </HyperLink>
            </PrismicLink>
          )}
        </div>
        {sideText && (
          <p className="bubble-sidetext">
            <ArrowLoopDoodle
              aria-hidden="true"
              UNSAFE_className="desktop-only"
            />
            <ArrowLoopDoodle
              aria-hidden="true"
              rotate={31}
              UNSAFE_className="mobile-only"
            />
            {sideText}
          </p>
        )}
      </div>
      <style jsx>{`
        .bubble-card {
          position: relative;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          margin-right: 80px;
          text-align: center;
          width: 326px;
          height: 226px;
          z-index: 0;
        }

        .bubble-title {
          margin-bottom: var(--space-4);
        }
        .bubble-card :global(.bubble-background) {
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }
        .bubble-card :global(.bubble-cta) {
          display: inline-flex;
          margin-top: var(--space-4);
        }
        .bubble-sidetext {
          position: absolute;
          right: -96px;
          top: 80px;
          width: 85px;
          font-size: var(--font-size-1);
          line-height: 1.2;
          font-style: italic;
          font-family: var(--font-family-default);
        }
        .bubble-sidetext :global(svg) {
          position: absolute;
          top: -45px;
          left: -35px;
        }

        @media (max-width: 850px) {
          .bubble-sidetext {
            right: -66px;
            width: 60px;
          }
        }
        @media (max-width: 800px) {
          .bubble-card {
            margin-right: 0;
            margin-bottom: var(--space-5);
            width: 301px;
            height: 251px;
          }

          .bubble-sidetext {
            right: -17px;
            top: calc(100% + 5px);
            width: 120px;
          }
          .bubble-sidetext :global(svg) {
            top: -45px;
            left: 68px;
          }
        }
        @media (max-width: 350px) {
          .bubble-sidetext {
            right: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default BubbleCard;
